
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import Gate from '@/components/Gate.vue';
import AppButton from '@/components/AppButton.vue';
import { GateData, GateAnswer } from '@/types';
import { MutationType } from '@/enums';

@Component({
	components: {
		Gate,
		AppButton
	}
})
export default class GateSurvey extends Vue {
	private get gates(): GateData[] {
		return this.$store.state.gates;
	}

	private getAnswer(gateId: number): GateAnswer {
		return this.$store.state.gateAnswers.find((a: GateAnswer) => a.id === gateId);
	}

	@Emit()
	private finish(): void {
		this.$store.commit(MutationType.FINISH_GATE_SURVEY);
	}
}
